import script from "./MapNewsList.vue?vue&type=script&setup=true&lang=js"
export * from "./MapNewsList.vue?vue&type=script&setup=true&lang=js"

import "./MapNewsList.vue?vue&type=style&index=0&id=457087e9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457087e9"]])

export default __exports__